import withPrefixSafe from "src/utils/withPrefixSafe";

/** Path segment for the standalone eligibility form document (no ThirdPartyScripts). */
export const ELIGIBILITY_FORM_EMBED_PATHNAME =
  "/for-individuals/eligibility-form";

function normalizePath(pathname: string): string {
  let end = pathname.length;
  while (end > 1 && pathname[end - 1] === "/") end--;
  return pathname.slice(0, end) || "/";
}

/**
 * True when the current route is the eligibility form embed page (iframe target).
 * Handles two call sites:
 *  - gatsby-ssr.tsx onRenderBody: receives the page route WITHOUT pathPrefix,
 *    so we also match the bare path (locale builds would otherwise fail because
 *    withPrefixSafe adds e.g. /nl/nl/ while pathname is still /for-individuals/…).
 *  - Runtime (window.location.pathname): receives the full path WITH pathPrefix,
 *    matched by the withPrefixSafe target.
 */
export function isEligibilityFormEmbedPath(pathname: string): boolean {
  const normalized = normalizePath(pathname);
  const withPrefixTarget = normalizePath(
    withPrefixSafe(ELIGIBILITY_FORM_EMBED_PATHNAME),
  );
  const bareTarget = normalizePath(ELIGIBILITY_FORM_EMBED_PATHNAME);
  return normalized === withPrefixTarget || normalized === bareTarget;
}
